import * as React from "react";
import Top from "./top";
import News from "./news";
import Education from "./education";
import Career from "./career";
import Research from "./research";
import Publication from "./publication";
import TalksSection from "./talksSection";
import Creation from "./creation";
import Award from "./award";
import Others from "./others";
const Main: React.FC = () => {
  return (
    <div>
      <Top />
      <section className="ftco-section">
        <News />
        <Research />
        <Career />
        <Education />
        <Publication />
        <TalksSection />
        <Award />
        <Creation />
        <Others />
      </section>
    </div>
  );
};

export default Main;
